import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Views
import "primereact/resources/themes/bootstrap4-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.min.css";
import AllProjects from "./pages/all-projects/AllProjects";
import CreateProject from "./pages/create-projects/CreateProject";
import EditProject from "./pages/edit-projects/EditProject";
import SingleReport from "./pages/all-projects/reports/SingleReport";
import EventReport from "./pages/all-projects/reports/EventReport";
import KeycloakService from "./services/KeycloakService";
import Devices from "./pages/devices/Devices";
import Settings from "./pages/user-settings/Settings";
import settings from "./config/settings";
import {Button} from 'primereact/button';
import {ConfirmDialog} from 'primereact/confirmdialog';
import { useTranslation } from "react-i18next";
import SlowTraceReport from "./pages/all-projects/reports/SlowTraceReport";


const Error404 = () => (
  <h1 style={{ display: "flex", justifyContent: "center" }}>
    404 – Seite nicht gefunden
  </h1>
);

const App = (): JSX.Element => {
    const { t } = useTranslation();
    const [keycloakToken, setKeycloakToken] = useState<string>("");
    const [confirmDialogVisible, setConfirmDialogVisible] = useState<boolean>(false);
    const onKeyCloakAuth = (token: string) => {
        setKeycloakToken(token);
    };

    const onSessionExpired = () => {
        setConfirmDialogVisible(true);
    };
    const logout = () => {
        const currentUrl = window.location.href;
        const keycloakIdToken = localStorage.getItem('keycloak-id-token');
        window.location.href = settings.logoutUrl
            + '?id_token_hint=' + keycloakIdToken
            + '&post_logout_redirect_uri=' + currentUrl;
    };

    const sessionExpiredDialogFooter = (
        <React.Fragment>
            <Button label={'Ok'} icon="pi pi-check" className="p-button-text" onClick={logout}/>
        </React.Fragment>
    );

  return (
    <Router>
      <div className="App">
        <KeycloakService onAuth={onKeyCloakAuth} onSessionExpired={onSessionExpired} />
          <ConfirmDialog
              className={'hide-x'}
              visible={confirmDialogVisible}
              message={t('session_expired_message')}
              header={t('session_expired')}
              icon="pi pi-exclamation-triangle"
              footer={sessionExpiredDialogFooter}
          />
        {keycloakToken !== "" && (
          <Routes>
            <Route path="/" element={<AllProjects />} />
            <Route path="/project/:projectId" element={<AllProjects />} />
            <Route path="/create-project" element={<CreateProject />} />
            <Route
              path="/edit-project/:name/:projectId"
              element={<EditProject />}
            />
            <Route path="/report" element={<SingleReport />} />
            <Route path="/event-report" element={<EventReport />} />
            <Route path="/slow-trace-report" element={<SlowTraceReport />} />
            <Route path="/device/:id/:project" element={<Devices />} />
            <Route path="/all-devices/" element={<Devices />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="*" element={<Error404 />} />
          </Routes>
        )}
      </div>
    </Router>
  );
};

export default App;
